import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HorizontalScroll from '../horizontal-scroll';
import listCSS from './list.styles'

/**
 * Renders a header, subtitle, and list (children).
 * @param children - React children, should be a an array.
 * @param className - Class applied to wrapper element.
 * @param subTitle - Text used for Subtitle.
 * @param title - Text used for title.
 * @param displayOption - Decides how to display list, see proptypes
 */
const List = ({
  children,
  className,
  displayOption,
  subTitle,
  title,
}) => {
  let listView;
  switch (displayOption) {
    case 'Horizontal Scroll': {
      listView = <HorizontalScroll>{children}</HorizontalScroll>;
      break;
    }
    default: {
      // Ported from previous list implementation
      // All the rest are legacy default styles that rely on
      // the following dom structure.
      // Eventually should break these in to own components
      listView = (
        <div className='Sections'>
          {children}
        </div>
      );
    }
  }

  const hasTitle = !!(title || subTitle);

  return (
    <div className={classnames('List', className, { hasTitle })}>
      {title ? <h2 className='h2 title'>{title}</h2> : null}
      {subTitle ? <div className='subTitle'>{subTitle}</div> : null}
      {listView}
    </div>
  );
};

List.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
  displayOption: PropTypes.oneOf([
    'Vertical List',
    'Full Width',
    'Grid',
    'Grid Two Columns',
    'Grid Three Columns',
    'Grid Four Columns',
    'Grid Five Columns',
    'Grid Six Columns',
    'Carousel',
    'Image Grid',
    'Horizontal Scroll',
    'Mad Lib Flow',
  ]),
  subTitle: PropTypes.node,
  title: PropTypes.node,
};

List.defaultProps = {
  children: null,
  className: '',
  displayOption: 'Vertical List',
  subTitle: '',
  title: '',
};

export default styled(List)`
${listCSS}
`;
